<template>
    <div>
        <v-dialog v-model="open" max-width="650px">
            <v-card>
                <v-toolbar flat dense color="primary" dark>
                    Proyectos
                    <v-spacer></v-spacer>
                    <v-btn icon small class="mr-1" @click="closeDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <v-card-text>
                    <v-toolbar class="my-4 rounded-lg" outlined flat v-if="selected">
                        <v-list-item-icon>
                            <v-icon>
                                mdi-google-circles-extended
                            </v-icon>
                        </v-list-item-icon>
                        {{ selected.name }}
                        <v-spacer></v-spacer>
                        <v-chip small color="accent">
                            Actual
                        </v-chip>
                    </v-toolbar>
                    <v-card flat outlined>
                        <v-toolbar
                            flat
                            dense
                            color="grey lighten-2"
                            class="text-caption font-weight-bold"
                        >
                            Lista de proyectos
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-virtual-scroll
                            bench="10"
                            :items="projects"
                            :item-height="80"
                            height="30vh"
                        >
                            <template v-slot:default="{ item }">
                                <v-list-item class="text-caption">
                                    <v-list-item-content>
                                        {{ item.name }}
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-chip
                                            small
                                            :outlined="!selected.id === item.id"
                                            :color="selected.id === item.id ? 'accent': undefined"
                                            @click="selectProject(item.id)"
                                            class="mb-1"
                                        >
                                            {{ selected.id === item.id ? 'Actual': 'Seleccionar' }}
                                        </v-chip>
                                        <v-chip
                                            small
                                            :outlined="!item.initial"
                                            :color="item.initial ? 'accent': undefined"
                                            @click="setAsInicial(item.id)"
                                        >
                                            Inicial
                                        </v-chip>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-divider></v-divider>
                            </template>
                        </v-virtual-scroll>
                    </v-card>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    name: 'ProjectsDialog',
    computed: {
        ...mapState({
            projects: (state) => state.projects.list,
            selected: (state) => state.projects.selected,
        }),
    },
    data() {
        return {
            open: false,
            smAndDown: this.$vuetify.breakpoint.smAndDown
        }
    },
    methods: {
        ...mapActions({
            setProject: 'projects/setProject',
            setInitialProject: 'projects/setInitialProject'
        }),
        selectProject(id){
            this.setProject(id)
        },
        setAsInicial(id){
            this.setInitialProject(id)
        },
        openDialog() {
            this.open = true
        },
        closeDialog() {
            this.open = false
        },
    },
}
</script>
